import { atom } from 'recoil';

const refetechAllSignerUsers = atom({
  key: 'refetechAllSignerUsers',
  default: 0
});


export { refetechAllSignerUsers };
